<div class="results-card">
  <div class="rt-section-title" *ngIf="title" [class.rt-plegable]="plegable">
    <span class="rt-title-main" (click)="togglePlegada()"
      [attr.role]="plegable ? 'button' : null" [attr.tabindex]="plegable ? 0 : null"
      (keydown.enter)="togglePlegada()" [attr.aria-expanded]="plegable ? !plegada : null"
      [title]="plegable ? 'Clic para mostrar/ocultar la tabla' : ''">
      <mat-icon *ngIf="plegable" class="rt-chevron">{{ plegada ? 'chevron_right' : 'expand_more' }}</mat-icon>
      <mat-icon>leaderboard</mat-icon>
      {{ title }} <span class="rt-count">{{data?.length || 0}} resultados</span>
    </span>
    <span class="rt-title-actions"><ng-content select="[rtTitleActions]"></ng-content></span>
  </div>
  <div class="results-body" [hidden]="plegada">
    <div class="ccorbit-mat-table col-panel-wrapper">
      <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
           [ngClass]="{'expanded': colPanelOpen}" [style.left.px]="colPanelLeftOffset">
        <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
          <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
        </div>
        <div class="col-panel-content">
          <h6 class="col-panel-title mb-2">Columnas</h6>
          <div class="col-panel-option" *ngFor="let column of tableColumns"
               [style.display]="column.id === 'modelMeetsCriteria' && !showModelMeetsCriteria ? 'none' : 'block'">
            <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id)" [color]="'primary'">{{column.name}}</mat-checkbox>
          </div>
        </div>
      </div>

      <cdk-virtual-scroll-viewport [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34"
        class="mat-elevation-z2 tableStyle" [style.height]="height">
        <table cdk-table [dataSource]="cdkTableData" class="table-striped tableStyle">
          <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
          <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (contextmenu)="onRowContextMenu($event, row)"
            [ngClass]="{'selected': row === selectedRow}"></tr>

          <!-- Match Column (visual only) -->
          <ng-container cdkColumnDef="match">
            <th cdk-header-cell *cdkHeaderCellDef class="sticky-header" style="width:48px;">Match</th>
            <td cdk-cell *cdkCellDef="let row" style="width:48px;">
              <ng-container *ngIf="matchIdFn; else dashFn">
                <ng-container *ngIf="matchIdFn(row) !== null; else dash">
                  <span class="match-badge">{{ matchIdFn(row) }}</span>
                </ng-container>
                <ng-template #dash><span class="match-badge match-badge--empty">-</span></ng-template>
              </ng-container>
              <ng-template #dashFn><span class="match-badge match-badge--empty">-</span></ng-template>
            </td>
          </ng-container>

          <!-- Checkbox Column -->
          <ng-container cdkColumnDef="select">
            <th cdk-header-cell *cdkHeaderCellDef class="sticky-header" style="width: 50px;">
              <mat-checkbox class="compact-checkbox" *ngIf="selection" (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td cdk-cell *cdkCellDef="let row" style="width: 50px;">
              <mat-checkbox class="compact-checkbox" *ngIf="selection" (click)="$event.stopPropagation()" (change)="toggleRow(row)"
                [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container *ngFor="let tablecol of tableColumns">
            <ng-container [cdkColumnDef]="tablecol.id">
              <th cdk-header-cell *cdkHeaderCellDef class="sticky-header" [class.pl-4]="tablecol.id === 'index'"
                (click)="tablecol.id !== 'index' && sortBy(tablecol.id)">
                {{tablecol.name}}
                <i class="material-icons align-middle ml-1" *ngIf="sortColumn === tablecol.id">
                  {{sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
                </i>
              </th>
              <td cdk-cell *cdkCellDef="let item" [ngClass]="{'pl-4': tablecol.id === 'index'}"
                [attr.title]="tablecol.id === 'condition' ? textoCondicionCompleto(item) : null">
                <!-- Index Column -->
                <ng-container *ngIf="tablecol.id === 'index'">
                  <strong>{{ item.index }}</strong>
                </ng-container>

                <!-- Type Column -->
                <ng-container *ngIf="tablecol.id === 'type'">
                  <a [href]="getModelLink(item)" target="_blank" class="ver-modelo-link"
                    (mouseenter)="showPreview($event, item)" (mouseleave)="hidePreviewDelayed()">
                    Ver 
                    <i class="material-icons icon-base">open_in_new</i>
                  </a>
                </ng-container>

                <!-- Condition Column -->
                <ng-container *ngIf="tablecol.id === 'condition'">
                  <div class="condition-block">
                    <div *ngIf="item.type === 'Condition'">
                      {{ item.condition && item.condition.length > 70 ? (item.condition | slice:0:70) + '…' :
                      item.condition }}
                    </div>
                    <!-- Una sola línea: el scroll virtual necesita filas de alto fijo (tvsItemSize) -->
                    <ng-container *ngIf="item.type === 'Combination'">
                      <ng-container *ngFor="let cond of item.conditions || []; let j = index; let last = last">
                        <small class="text-muted mr-1">{{j + 1}}.</small>{{ cond.length > 70 ? (cond | slice:0:70) + '…' : cond }}<span *ngIf="!last" class="cond-sep"> · </span>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>

                <!-- Compound Rate Column -->
                <ng-container *ngIf="tablecol.id === 'compoundRate'">
                  <span [ngClass]="item.compoundRate > 12 ? 'text-success font-weight-bold' : ''">
                    {{ item.compoundRate | number:'1.2-2' }}%
                  </span>
                </ng-container>

                <!-- Max Drawdown Column -->
                <ng-container *ngIf="tablecol.id === 'maxDrawdown'">
                  <span class="text-danger">
                    {{ item.maxDrawdown | number:'1.2-2' }}%
                  </span>
                </ng-container>

                <!-- Max Drawdown Objetivo Column -->
                <ng-container *ngIf="tablecol.id === 'maxDrawdownObjetivo'">
                  <span class="text-danger">
                    {{ item.maxDrawdownObjetivo | number:'1.2-2' }}%
                  </span>
                </ng-container>

                <!-- Beneficio $ Column -->
                <ng-container *ngIf="tablecol.id === 'beneficio'">
                  <span [ngClass]="item.beneficio > 0 ? 'text-success font-weight-bold' : 'text-danger'">
                    ${{ item.beneficio | number:'1.2-2' }}
                  </span>
                </ng-container>

                <!-- Max Drawdown Valor $ Column -->
                <ng-container *ngIf="tablecol.id === 'maxDrawdownValor'">
                  <span class="text-danger">
                    ${{ item.maxDrawdownValor | number:'1.2-2' }}
                  </span>
                </ng-container>

                <!-- Stop Loss Column -->
                <ng-container *ngIf="tablecol.id === 'stopLoss'">
                  <ng-container *ngIf="item.stoplossActivo; else stopLossDash">
                    <span>{{ (item.stopLoss ?? 0) | number:'1.2-2' }}%</span>
                  </ng-container>
                  <ng-template #stopLossDash>-</ng-template>
                </ng-container>

                <!-- Profit Column -->
                <ng-container *ngIf="tablecol.id === 'profit'">
                  <ng-container *ngIf="item.profitActivo; else profitDash">
                    <span>{{ (item.profit ?? 0) | number:'1.2-2' }}%</span>
                  </ng-container>
                  <ng-template #profitDash>-</ng-template>
                </ng-container>

                <!-- Días Salida Column -->
                <ng-container *ngIf="tablecol.id === 'diasSalida'">
                  <ng-container *ngIf="item.diasSalidaActivo; else diasSalidaDash">
                    <span>{{ (item.diasSalida ?? 0) | number:'1.0-0' }}</span>
                  </ng-container>
                  <ng-template #diasSalidaDash>-</ng-template>
                </ng-container>

                <!-- Valor Riesgo Column -->
                <ng-container *ngIf="tablecol.id === 'valorriesgo'">
                  <ng-container
                    *ngIf="item.valorriesgo !== null && item.valorriesgo !== undefined; else valorriesgoDash">
                    <span>{{ item.valorriesgo | number:'1.2-2' }}</span>
                  </ng-container>
                  <ng-template #valorriesgoDash>-</ng-template>
                </ng-container>

                <!-- Tasa/M.D. Ratio Column -->
                <ng-container *ngIf="tablecol.id === 'tasaMDRatio'">
                  <ng-container *ngIf="item.beneficio != 0; else tasaMDBlank">
                    <span
                      [ngClass]="getTasaMDRatio(item) > 1 ? 'text-success font-weight-bold' : ''">
                      {{ getTasaMDRatio(item) | number:'1.2-2' }}
                    </span>
                  </ng-container>
                  <ng-template #tasaMDBlank></ng-template>
                </ng-container>

                <!-- Operaciones Column -->
                <ng-container *ngIf="tablecol.id === 'operaciones'">
                  <span>{{ item.operaciones | number:'1.0-0' }}</span>
                </ng-container>

                <!-- Score Column -->
                <ng-container *ngIf="tablecol.id === 'score'">
                  <span [ngClass]="item.score > -5 ? 'text-success font-weight-bold' : ''">
                    {{ item.score | number:'1.2-4' }}
                  </span>
                </ng-container>

                <!-- Model Meets Criteria Column -->
                <ng-container *ngIf="tablecol.id === 'modelMeetsCriteria' && showModelMeetsCriteria">
                  <span>{{ item.modelMeetsCriteria }}</span>
                </ng-container>
              </td>
            </ng-container>
          </ng-container>
        </table>
      </cdk-virtual-scroll-viewport>
      <!-- Hover preview popover -->
      <div *ngIf="previewVisible" class="results-preview-popover"
        [ngStyle]="{'position':'fixed','top.px': previewTop,'left.px': previewLeft,'z-index':2000,'width.px':360,'height.px':240,'background':'var(--nec-surface)','border':'1px solid var(--nec-border)','box-shadow':'0 6px 18px rgba(0,0,0,0.35)','border-radius':'4px','overflow':'hidden'}"
        (mouseenter)="keepPreview()" (mouseleave)="hidePreviewDelayed()">
        <app-grafica-rendimiento [isPlanificador]="true" [isGestion]="false"
          [isBroker]="false" origen="STRATEGYFACTORY"></app-grafica-rendimiento>
      </div>

    </div>
  </div>
</div>